import { NotificationsQuery } from 'shared/hooks/api/notifications/notifications.generated';
import { mapDtoToNotification, Notification } from 'types/Notification';
import { create } from 'zustand/index';

interface ModalStoreType {
  notifications: Notification[];
  markNotificationAsViewed: (id: string, viewedAt: Date) => void;
  markManyNotificationsAsViewed: (updatedNotifications: UpdatedNotification[]) => void;
  loadNotifications: (dto: NotificationsQuery['expertNotifications']['notifications']) => void;
  clearNotifications: () => void;
}

interface UpdatedNotification {
  id: string;
  viewedAt?: Date | null;
}

export const useNotificationStore = create<ModalStoreType>((set) => ({
  notifications: [],
  markNotificationAsViewed: (id: string, viewedAt: Date) =>
    set((prev) => ({
      notifications: prev.notifications.map((notif) =>
        notif.id === id ? { ...notif, viewedAt } : notif,
      ),
    })),
  markManyNotificationsAsViewed: (updatedNotifications: UpdatedNotification[]) =>
    set((prev) => {
      const updatedPrev = prev.notifications.map((notif) => {
        const updatedNotification = updatedNotifications.find(
          (updatedNotif) => notif.id === updatedNotif.id,
        );
        if (!updatedNotification) {
          return notif;
        }
        return {
          ...notif,
          viewedAt: updatedNotification.viewedAt || null,
        };
      });
      return {
        notifications: updatedPrev,
      };
    }),
  loadNotifications: (dto: NotificationsQuery['expertNotifications']['notifications']) =>
    set({ notifications: dto.map(mapDtoToNotification).filter((notif) => !!notif) }),
  clearNotifications: () => set({ notifications: [] }),
}));
